var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsteamsColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.5,
    height: 40.5,
    viewBox: "0 0 40.5 40.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.174,
    y1: 1.067,
    x2: 0.826,
    y2: -0.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4d55bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940ab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams",
    transform: "translate(-1107.75 -159.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160354",
    "data-name": "Group 160354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle",
    transform: "translate(1108 160)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#dce1e9",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Teams_-_Color",
    "data-name": "Teams - Color",
    transform: "translate(208 -453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_Office_Teams__2018_present_",
    "data-name": "Microsoft_Office_Teams_(2018\\u2013present)",
    transform: "translate(907 620.907)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M1503.769,777.5h6.716a1.149,1.149,0,0,1,1.148,1.149h0v6.117a4.222,4.222,0,0,1-4.222,4.222h-.02a4.223,4.223,0,0,1-4.223-4.222h0V778.1a.6.6,0,0,1,.6-.6Z",
    transform: "translate(-1485.634 -768.43)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 2.721,
    cy: 2.721,
    r: 2.721,
    transform: "translate(19.953 2.419)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 3.93,
    cy: 3.93,
    r: 3.93,
    transform: "translate(10.279 0)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M634.035,777.5H622.949a1.136,1.136,0,0,0-1.108,1.163v6.977a6.659,6.659,0,1,0,13.3,0v-6.977A1.137,1.137,0,0,0,634.035,777.5Z",
    transform: "translate(-614.585 -768.43)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M629.228,777.5v9.777a1.114,1.114,0,0,1-.689,1.022,1.069,1.069,0,0,1-.417.085H622.5c-.079-.2-.151-.4-.212-.6a7.372,7.372,0,0,1-.32-2.14v-6.978a1.135,1.135,0,0,1,1.106-1.161Z",
    transform: "translate(-614.717 -768.43)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M628.624,777.5v10.382a1.072,1.072,0,0,1-.085.417,1.113,1.113,0,0,1-1.022.689h-4.728c-.1-.2-.2-.4-.284-.6a5.965,5.965,0,0,1-.212-.6,7.372,7.372,0,0,1-.32-2.14v-6.978a1.135,1.135,0,0,1,1.106-1.161Z",
    transform: "translate(-614.717 -768.43)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M628.628,777.5v9.172a1.115,1.115,0,0,1-1.107,1.106H622.3a7.364,7.364,0,0,1-.32-2.14v-6.978a1.135,1.135,0,0,1,1.106-1.161Z",
    transform: "translate(-614.721 -768.43)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M628.02,777.5v9.172a1.115,1.115,0,0,1-1.107,1.106h-4.62a7.372,7.372,0,0,1-.32-2.14v-6.978a1.135,1.135,0,0,1,1.107-1.161Z",
    transform: "translate(-614.718 -768.43)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M894.62,415.774v1.9c-.1.006-.2.012-.3.012s-.2-.006-.3-.012a3.316,3.316,0,0,1-.6-.1,3.93,3.93,0,0,1-2.721-2.31,3.337,3.337,0,0,1-.193-.6h3.017A1.111,1.111,0,0,1,894.62,415.774Z",
    transform: "translate(-880.108 -409.831)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M910.413,467.607v1.3a3.318,3.318,0,0,1-.6-.1,3.931,3.931,0,0,1-2.721-2.31h2.219A1.111,1.111,0,0,1,910.413,467.607Z",
    transform: "translate(-896.506 -461.059)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M910.413,467.607v1.3a3.318,3.318,0,0,1-.6-.1,3.931,3.931,0,0,1-2.721-2.31h2.219A1.111,1.111,0,0,1,910.413,467.607Z",
    transform: "translate(-896.506 -461.059)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M909.8,467.606v1.2a3.93,3.93,0,0,1-2.721-2.31h1.614A1.111,1.111,0,0,1,909.8,467.606Z",
    transform: "translate(-896.499 -461.058)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M1.108,466.5H12.194a1.108,1.108,0,0,1,1.108,1.108v11.086a1.108,1.108,0,0,1-1.108,1.108H1.108A1.108,1.108,0,0,1,0,478.694V467.608A1.108,1.108,0,0,1,1.108,466.5Z",
    transform: "translate(0 -461.058)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M325.957,729.014h-2.216v6.035h-1.412v-6.035h-2.206v-1.171h5.834Z",
    transform: "translate(-316.389 -719.354)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 26,
    height: 26,
    transform: "translate(907 620)",
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsteamsColorIcon);
export default __webpack_public_path__ + "static/media/msteams-color-icon.4e29aa3936a0cc76afe65a3cc3db1afc.svg";
export { ForwardRef as ReactComponent };